import { getDocument, getTimeout, getWindow } from '@/helpers/globals'

export type ScrollIntoViewOffset = {
    left: number
    top: number
}

export function useScrollIntoView(
    selector: string,
    offset: ScrollIntoViewOffset = { left: 0, top: 110 }
) {
    const document = getDocument()
    const window = getWindow()
    const { setTimeout } = getTimeout() ?? { setTimeout: undefined }

    const scrollIntoView = () =>
        // make sure it runs after default router scrollBehavior
        setTimeout?.(() => {
            if (!document) {
                return
            }

            const el = document.querySelector(selector)

            if (!el) {
                return
            }

            const docRect = document.documentElement.getBoundingClientRect()
            const elRect = el.getBoundingClientRect()
            const options = {
                behavior: 'smooth',
                left: elRect.left - docRect.left - (offset.left || 0),
                top: elRect.top - docRect.top - (offset.top || 0),
            } as const

            if ('scrollBehavior' in document.documentElement.style) {
                window?.scrollTo(options)
            } else {
                window?.scrollTo(
                    options.left != null ? options.left : window.scrollX,
                    options.top != null ? options.top : window.scrollY
                )
            }
        })

    return { scrollIntoView }
}
